export type SalesDeskPage =
  | "home"
  | "start"
  | "lot"
  | "configure"
  | "orders"
  | "record"
  | "matches"
  | "stockForm"
  | "performance"
  | "restock";

export const SALES_DESK_NAV: Array<{ id: Extract<SalesDeskPage, "home" | "lot" | "orders" | "performance" | "restock">; label: string; glyph: string }> = [
  { id: "home", label: "Home", glyph: "⌂" },
  { id: "lot", label: "My lot", glyph: "▱" },
  { id: "orders", label: "Orders", glyph: "⌕" },
  { id: "performance", label: "Performance", glyph: "▥" },
  { id: "restock", label: "Restock", glyph: "↻" },
];

export const deskPrimaryBtn =
  "rounded-lg bg-[#164b43] px-5 py-3.5 text-center font-semibold text-white";
export const deskSecondaryBtn =
  "rounded-lg border border-[#dce3dc] bg-white px-5 py-3.5 text-center font-semibold text-[#142d2d] dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100";
export const deskCard =
  "rounded-[13px] border border-[#dce3dc] bg-white p-[22px] dark:border-zinc-700 dark:bg-zinc-900";
export const deskEyebrow = "text-[11px] font-bold uppercase tracking-[2px] text-[#164b43] dark:text-emerald-300";
export const deskMuted = "text-[15px] text-[#687772] dark:text-zinc-400";
